import determineStage from '../DetermineStage';

const getDateForComplianceCheck = (initiative, stageToCheck) => {
  const timelineEntry = initiative?.timeline?.find((entry) => entry.stage === stageToCheck);
  return {
    plan: timelineEntry?.date?.plan,
    actual: timelineEntry?.date?.actual
  };
};

const getComplianceStatus = (initiative, stageToCheck) => {
  const dates = getDateForComplianceCheck(initiative, stageToCheck);
  const targetPlanDate = dates.plan;
  const targetActualDate = dates.actual;

  if (!targetPlanDate) {
    return ['Not Planned'];
  }

  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  const plannedDate = new Date(targetPlanDate);
  plannedDate.setHours(0, 0, 0, 0);

  const currentStage = initiative.stage;

  // 1. Check if there's an actual date
  if (targetActualDate) {
    const actualDate = new Date(targetActualDate);
    actualDate.setHours(0, 0, 0, 0);

    // Calculate difference between planned and actual dates
    const plannedVsActualDiff = Math.ceil((actualDate.getTime() - plannedDate.getTime()) / (1000 * 60 * 60 * 24));

    // Accelerated: Actual date is earlier than planned date
    if (plannedVsActualDiff < 0) {
      return ['Accelerated'];
    }
    // Unchanged: Actual date equals planned date
    else if (plannedVsActualDiff === 0) {
      return ['Unchanged'];
    }
    // Delayed: Actual date is later than planned date
    else {
      const delayDays = Math.abs(plannedVsActualDiff);
      if (delayDays <= 7) return ['Delayed (1 to 7 days)'];
      if (delayDays <= 14) return ['Delayed (8 to 14 days)'];
      if (delayDays <= 30) return ['Delayed (15 to 30 days)'];
      if (delayDays <= 90) return ['Delayed (1 to 3 months)'];
      return ['Delayed (more than 3 months)'];
    }
  }

  // 2. No actual date yet - calculate days difference between planned date and current date
  const daysDifference = Math.ceil((plannedDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));

  // Check if initiative is "New" (created within last 7 days)
  if (initiative.created) {
    const createdDate = new Date(initiative.created);
    createdDate.setHours(0, 0, 0, 0);
    const daysSinceCreated = Math.ceil((currentDate.getTime() - createdDate.getTime()) / (1000 * 60 * 60 * 24));
    if (daysSinceCreated <= 7) {
      return ['New'];
    }
  }

  // Accelerated: Initiative is already at target stage but planned date is still in future
  if (currentStage === stageToCheck && daysDifference > 0) {
    return ['Accelerated'];
  }

  // Unchanged: Planned date is today
  if (daysDifference === 0) {
    return ['Unchanged'];
  }

  // On Plan: Planned date is in future and initiative not yet at target stage
  if (daysDifference > 0 && currentStage !== stageToCheck) {
    return ['On Plan'];
  }

  // Delayed: Planned date is in past (daysDifference < 0) and initiative not at target stage
  if (daysDifference < 0 && currentStage !== stageToCheck) {
    const delayDays = Math.abs(daysDifference);
    if (delayDays <= 7) return ['Delayed (1 to 7 days)'];
    if (delayDays <= 14) return ['Delayed (8 to 14 days)'];
    if (delayDays <= 30) return ['Delayed (15 to 30 days)'];
    if (delayDays <= 90) return ['Delayed (1 to 3 months)'];
    return ['Delayed (more than 3 months)'];
  }

  // Default fallback
  return ['<not set>'];
};

export default getComplianceStatus;